import { DEAD_SESSION_CODES } from '../../../gql/refreshFailure';

/**
 * Qué dice el aviso del login según el motivo del cierre (spec § 5.4 y § 12.6).
 * Va en un toast (pedido del usuario, 2026-10-09), así que UN texto:
 * - refresh caducado con trabajo en cola → «La sesión ha caducado. Vuelve a
 *   iniciar sesión para enviar lo que has guardado sin conexión.» (ya incluye
 *   lo de la sesión: juntarlo con el otro repetía «caducado»);
 * - refresh caducado sin cola → «Tu sesión ha caducado. Vuelve a entrar.»;
 * - cuenta inactiva o borrada → no puede «volver a entrar para enviar».
 */
export function sessionEndedNoticeKey(reason: string | null, hasQueuedWork: boolean): string | null {
  if (!reason || !(DEAD_SESSION_CODES as readonly string[]).includes(reason)) return null;
  if (reason !== 'AUTH_REFRESH_EXPIRED') return 'auth:sessionEnded.accountUnavailable';
  return hasQueuedWork ? 'common:offline.sessionExpired' : 'auth:sessionEnded.expired';
}
